// extracted by mini-css-extract-plugin
export var actions = "_r2-5";
export var assistantBubble = "_r2-3";
export var assistantRow = "_r2-6";
export var bubble = "_r2-0";
export var humanAvatar = "_r2-4";
export var inlineToolCard = "_r2-1";
export var userBubble = "_r2-2";